import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

interface Props {
    showModal: boolean;
    versionId: number | null;
    versionHashCode: string | null;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    showModal: false,
    versionId: null,
    versionHashCode: null,
    update: (value) => set({ ...value }),
});

export const useCopyVersionStore = create(state);
